export const root = document.getElementById('root');
export const portalRoot = document.getElementById('portal-root');
